import axios from "axios";

// Salary Sheet — mutations + download. GETs live in appApi.js.
// Auth + x-project-id come from the global axios interceptor.

const API = `${
  process.env.REACT_APP_API_URL || "http://localhost:5001"
}/api/salary-sheet`;

export const createSsCompanyApi = (payload) => axios.post(`${API}/companies`, payload);

export const updateSsCompanyApi = (id, payload) =>
  axios.put(`${API}/companies/${id}`, payload);

export const updateSsConfigApi = (payload) => axios.put(`${API}/config`, payload);

export const upsertSsProfileApi = (employeeId, payload) =>
  axios.put(`${API}/profiles/${employeeId}`, payload);

export const postSsAdvanceApi = (employeeId, payload) =>
  axios.post(`${API}/profiles/${employeeId}/advance`, payload);

export const generateSsRunApi = (payload) => axios.post(`${API}/runs`, payload);

export const updateSsRowApi = (runId, rowId, payload) =>
  axios.patch(`${API}/runs/${runId}/rows/${rowId}`, payload);

export const setSsRowPaidApi = (runId, rowId, payload) =>
  axios.patch(`${API}/runs/${runId}/rows/${rowId}/paid`, payload);

export const finaliseSsRunApi = (runId, reopen = false) =>
  axios.post(`${API}/runs/${runId}/finalise`, { reopen });

export const deleteSsRunApi = (runId) => axios.delete(`${API}/runs/${runId}`);

export const downloadSsRunExcel = async (runId, monthKey) => {
  const res = await axios.get(`${API}/runs/${runId}/export`, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `salary-sheet-${monthKey || runId}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
